import { observer } from 'mobx-react';
import * as React from 'react';
import { T, TPlainTextKey } from '../../../../Translations';
import CopyRow from '../../CopyRow';
import { ConnectionResource, SsoVendor } from '../../Types';

interface Props {
  resource: ConnectionResource;
}

const instruction = (vendor: SsoVendor): TPlainTextKey => {
  switch (vendor) {
    case 'entra':
      return 'In Entra ID, create an Enterprise application, choose Set up single sign-on with SAML, and enter these values in Basic SAML Configuration:';
    case 'okta':
      return 'In Okta, create a SAML 2.0 app integration and enter these values:';
    case 'adfs':
      return 'In ADFS, add a Relying Party Trust for ExecOnline and enter these values:';
    case 'ping':
      return 'In PingFederate, create an SP connection for ExecOnline and enter these values:';
    case 'other':
      return 'In your identity provider, create a SAML 2.0 application and enter these values:';
  }
};

const SpDetailsCard: React.FC<Props> = ({ resource }) => (
  <div>
    <h3 className="text-base font-semibold text-foreground">
      <T kind="Configure your identity provider application" />
    </h3>
    <div className="mt-3 rounded-lg border border-border bg-card p-6">
      <p className="text-sm text-muted-foreground">
        <T kind={instruction(resource.payload.vendor)} />
      </p>
      <div className="mt-4 rounded-lg border border-border">
        <CopyRow
          label="Identifier"
          hint={<T kind="Entity ID / Audience URI" />}
          value={resource.payload.spDetails.entityId}
          monospaced={true}
        />
        <CopyRow
          label="Reply URL"
          hint={<T kind="Assertion Consumer Service" />}
          value={resource.payload.spDetails.acsUrl}
          monospaced={true}
        />
        <CopyRow
          label="Relay state"
          hint={<T kind="Required for IdP-initiated sign-in - identifies your organization" />}
          value={resource.payload.spDetails.relayState}
          monospaced={true}
        />
      </div>
      <p className="mt-4 text-sm text-muted-foreground">
        <T kind="Technical requirements: persistent NameID format (urn:oasis:names:tc:SAML:2.0:nameid-format:persistent), RSA-SHA256 signature algorithm, and a signed assertion." />
      </p>
    </div>
  </div>
);

export default observer(SpDetailsCard);
